import React from "react";
import headerlogo from "../utils/images/header-logo.svg";

const CustomLoader = ({ loading }) => {

    return (
        <div className={`loader-container ${loading ? "show" : "hide"}`}>
            <div class="spinner-box">
                <div class="circle-border">
                    <div class="circle-core">
                    </div>
                </div>
                <img src={headerlogo} alt=""  className="loader-logo"/>
            </div>
        </div>
    );
};

export default CustomLoader;
